import mpx from '@mpxjs/core'
import apiProxy from '@mpxjs/api-proxy'
import fetch from '@didi/mpx-fetch'
import {
  initSDK,
  init,
  query,
  hashQuery,
  canIUse,
  setLoginConfig,
  utils,
} from '@didi/webx-js'
import { setNativeNavBar } from '@/lib/webx/utils/set_native_navbar'
import { EnumNavStyle } from '@/lib/webx/defines'
import { mpGuide } from './mp_guide'
import { checkByPagePath } from '../webx/global_env/checkParams'
import { initTokenGuard } from './token-guard'

mpx.use(apiProxy, { usePromise: true }).use(fetch)

initSDK({
  branch: 'passenger',
})

initTokenGuard(utils.pageShow)

setNativeNavBar({
  navihidden: 0,
  navstyle: EnumNavStyle.Black,
  bgcolor: '#FFFFFF',
  titlecolor: '#333333',
})

const Queries = {
  ...query(),
  ...hashQuery(),
}

mpGuide()
checkByPagePath()

init({
  initOption: {
    config: {
      need_share_config: false,
      need_page_config: false,
      prod_key: 'quartz-mall',
      dchn: Queries.dchn || '',
    },
    quitInitProduct: false,
    env: process.env.BUILD_ENV === 'offline' ? 'offline' : 'online',
  },
}).then(res => {
  mpx.xpsid = res.xpsid || ''
  mpx.xpsidRoot = res.xpsid_root || ''
  mpx.xenv = res.xenv
})

canIUse('setLoginConfig') &&
  setLoginConfig({
    loginType: 'trinity',
    productType: 'didi',
    useOauthCode: true,
    offline: process.env.PASSPORT_ENV === 'offline',
  })
